import React, { Component } from 'react'
import { connect } from 'react-redux';
import * as wActs from '../actions/website-actions';
import * as pActs from '../actions/profiles-actions';
import {withRouter} from 'react-router-dom'
class ProfilesFilter extends Component {

  genIncludes() {
    let includes = "";
    let fData = null;
    if(!wActs.isNullOrUndefined(this.props.WebPage.Page.Menu) && !wActs.isNullOrUndefined(this.props.WebPage.Page.Menu.Filter)) {
      fData = this.props.WebPage.Page.Menu.Filter;
    } else {
      fData = this.props.filters;
    }
    fData.map((v) => {
      let ele = document.getElementById("filter-" + v.Index);
      if(ele) {
        if(!ele.value.startsWith("/") && ele.checked && !wActs.isNullOrEmpty(v.Settings.Filter)) {
          //console.log("Value:" + ele.value)
          includes += (v.Settings.Filter + ",");
        }
      }
      return null;
    });
    if(includes.endsWith(",")) {
      includes=includes.substr(0,includes.length-1);
    }
    return includes;
  }

  handleFilter(e) {
    let incs = this.genIncludes();
    let val = e.target.value;
    let chk = e.target.checked;
    if(val.startsWith("/") && chk) {
      this.props.history.push(val);
    } else {
      this.props.dispatch(pActs.filterProfiles({Include: incs, Exclude: ""}));
    }
  }

  handleReset(e) {
    //console.log("Here");
    let incs = "";
    this.filterReset.checked = false;
    this.props.dispatch(pActs.filterProfiles({Include: incs, Exclude: ""}));
  }

  currentFilter(v) {
    let pth = this.props.WebPage.ServerParams.Path;
    if(typeof window !== "undefined") { //Compare Path For New Url Type Filters
       pth = window.location.pathname
    }
    if(!wActs.isNullOrUndefined(v.Page) && !wActs.isNullOrUndefined(v.Page.Path)) {
      if(pth.toLowerCase() == v.Page.Path.toLowerCase()) {
        return true
      }
    }
    if(wActs.isNullOrUndefined(v.Settings.Filter)) { return false; }
    if(wActs.isNullOrUndefined(this.props.ProfilesList.Filter) || wActs.isNullOrUndefined(this.props.ProfilesList.Filter.Include)) { return false; }
    let curFilters = this.props.ProfilesList.Filter.Include.split(",");
    let chkFilter = v.Settings.Filter
    if(curFilters.length<=0) { return false; }
    let fnd = false;
    curFilters.map((v) => {
      if(v === chkFilter) {
        fnd = true;
      }
    });
    return fnd;
  }

  getTranslation(key)
  {
    return this.props.WebPage.Translations[key];
  }

  handleCountryChange(e) {
    console.log(e);

  }
  handleCityChange(e) {
    console.log(e);

  }

  render() {
    if(!this.props.WebPage.ShowingFilter) { return null; }
    if(this.props.WebPage.Page.Name === "404") { return null;}
    let pfilters = null;
    let cfilters = null;
    let fData = null;
    if(!wActs.isNullOrUndefined(this.props.WebPage.Page.Menu) && !wActs.isNullOrUndefined(this.props.WebPage.Page.Menu.Filter)) {
      fData = this.props.WebPage.Page.Menu.Filter;
    } else {
      fData = this.props.filters;
    }

    const pthFils = fData.filter((t) => {
      return (!wActs.isNullOrUndefined(t.Page) && !wActs.isNullOrUndefined(t.Page.Path)) || t.IsTop;
    });
    const comFils = fData.filter((t) => {
      return !t.IsTop;
    });


    let showCities = true;
    let showCountries = true;

    let cities = null;
    let countries = null;

    if(!wActs.isNullOrUndefined(this.props.WebPage.Menu.PopularCities) && this.props.WebPage.Menu.PopularCities.length>0) {
      cities = this.props.WebPage.Menu.PopularCities[0].Menu;
      if(!wActs.isNullOrUndefined(this.props.WebPage.Page.Menu) && !wActs.isNullOrUndefined(this.props.WebPage.Page.Menu.Cities)) {
        cities = this.props.WebPage.Page.Menu.Cities;
      }
    } else {
      showCities = false;
    }
    if(!wActs.isNullOrUndefined(this.props.WebPage.Menu.PopularCountries) && this.props.WebPage.Menu.PopularCountries.length>0) {
      countries = this.props.WebPage.Menu.PopularCountries[0].Menu;
    } else {
      showCountries = false;
    }

    if(this.props.WebPage.Settings.ShowCountries === false) {
      showCountries = false;
    }
    if(this.props.WebPage.Settings.ShowCities === false) {
      showCities = false;
    }
    if(this.props.pos == "bottom") {
      showCountries = false; showCities = false;
    }



    let CatPos = wActs.isNullOrUndefined(this.props.WebPage.Settings.CategoriesPosition) ? "top" : this.props.WebPage.Settings.CategoriesPosition.toLowerCase();
    let FilPos = wActs.isNullOrUndefined(this.props.WebPage.Settings.FiltersPosition) ? "top" : this.props.WebPage.Settings.FiltersPosition.toLowerCase();
    if(this.props.WebPage.ServerParams.IsMobile) {
      CatPos = wActs.isNullOrUndefined(this.props.WebPage.Settings.MobileCategoriesPosition) ? "top" : this.props.WebPage.Settings.MobileCategoriesPosition.toLowerCase();
      FilPos = wActs.isNullOrUndefined(this.props.WebPage.Settings.MobileFiltersPosition) ? "top" : this.props.WebPage.Settings.MobileFiltersPosition.toLowerCase();
    }



    if(fData !== "undefined") {
      if(CatPos == this.props.pos) {
        pfilters = pthFils.map((v,i) => {
          //console.log(v);
          let fnd = this.currentFilter(v);
          let pth = !wActs.isNullOrUndefined(v.Page) && !wActs.isNullOrUndefined(v.Page.Path) ? v.Page.Path : v.Name;
          return (
            <li key={"filter-check" + i} className="checkbox-input">
              {fnd && <input checked="checked" type="checkbox" className="filter-button" id={"filter-" + v.Index} value={pth} onChange={(e)=>this.handleFilter(e)}/>}
              {!fnd && <input type="checkbox" className="filter-button" id={"filter-" + v.Index} value={pth} onChange={(e)=>this.handleFilter(e)}/>}
              <label htmlFor={"filter-" + v.Index} className={fnd ? "active" : ""}>{v.Title}</label>
            </li>
          );
        });
        if(FilPos !== this.props.pos) {
          pfilters.push(
            <li key={"filter-reset"} className="checkbox-input">
              {<input type="checkbox" className="filter-button" id={"filter-reset-check"} value="" ref = {(ref) => {this.filterReset = ref}} onChange={(e)=>this.handleReset(e)}/>}
              <label htmlFor={"filter-reset-check"}>{this.getTranslation("page.reset")}</label>
            </li>
          )
        }
      }
      if(FilPos == this.props.pos) {
        cfilters = comFils.map((v,i) => {
          //console.log(v);
          let fnd = this.currentFilter(v);
          let pth = !wActs.isNullOrUndefined(v.Page) && !wActs.isNullOrUndefined(v.Page.Path) ? v.Page.Path : v.Name;
          //console.log(pth)
          return (
            <li key={"filter-check" + i} className="checkbox-input">
              {fnd && <input checked="checked" type="checkbox" className="filter-button" id={"filter-" + v.Index} value={pth} onChange={(e)=>this.handleFilter(e)}/>}
              {!fnd && <input type="checkbox" className="filter-button" id={"filter-" + v.Index} value={pth} onChange={(e)=>this.handleFilter(e)}/>}
              <label htmlFor={"filter-" + v.Index} className={fnd ? "active" : ""}>{v.Title}</label>
            </li>
          );
        });
        cfilters.push(
          <li key={"filter-reset"} className="checkbox-input">
            {<input type="checkbox" className="filter-button" id={"filter-reset-check"} value="" ref = {(ref) => {this.filterReset = ref}} onChange={(e)=>this.handleReset(e)}/>}
            <label htmlFor={"filter-reset-check"}>{this.getTranslation("page.reset")}</label>
          </li>
        )
      }
    }

    return (
        <div className="row">
          <div className="col-sm-12">
            <div className="models-sort">
              <ul className="sort-escorts" style={{float: "left"}}>
                {pfilters}
              </ul>


              <div className="dropdown-select" style={{float: "right"}}>
              {showCountries &&
                <div className="right-select">
                  <select name="" id="" className="model-country" onChange={(e) => {this.handleCityChange(e)}}>
                    <option value=""></option>
                    {countries.map((v,i) => {
                      return (
                        <React.Fragment key={"cc-select-" + i}>
                          <option value={v.Page.Path}>{v.Title}</option>
                        </React.Fragment>
                      );
                    })}
                  </select>
                </div>
                }
                {showCities &&
                  <div className="right-select">
                    <select name="" id="" className="model-city" onChange={(e) => {this.handleCountryChange(e)}}>
                      <option value=""></option>
                      {cities.map((v,i) => {
                        return (
                          <React.Fragment key={"city-select-" + i}>
                            <option value={v.Page.Path}>{v.Title}</option>
                          </React.Fragment>
                        );
                      })}
                    </select>
                  </div>
                }
                </div>




              <div style={{clear: "both", marginBottom: "15px"}}></div>
              <ul className="sort-escorts" style={{float: "left"}}>
                {cfilters}
              </ul>

            </div>
          </div>
        </div>
    );
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    try {
      if(typeof window !== "undefined") {
        let showCountries = true; let showCities = true;
        if(this.props.WebPage.Settings.ShowCountries === false) {
          showCountries = false;
        }
        if(this.props.WebPage.Settings.ShowCities === false) {
          showCities = false;
        }
        window.WireSelects(
          showCountries ? (cc) => {this.props.history.push(cc);} : null,
          showCities ? (city) => {this.props.history.push(city);} : null,
          this.getTranslation("dash.country"), this.getTranslation("page.profile.city"));
      }
    } catch(ex) {
      console.log(ex);
    }
  }
}

const mapStateToProps = (state) => {
  return {
    ProfilesList: state.ProfilesList, WebPage: state.Website
  }
}

export default withRouter(connect(mapStateToProps)(ProfilesFilter));
